/**
* @FileDescription: 团队认证
* @Author: zhuangjinshan
* @Date: 2025-12-29
*/
// import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js'

const TeamAuthApi = {
  /**
   * @description: 基础地址
   */
  baseUrl: function () {
    return '/longstron/applet/eco/certification';
  },
};

export default Object.assign(TeamAuthApi, BaseApi);
